import React, { useCallback, useEffect, useRef, useState } from 'react';
import StepUpModal from './StepUpModal';
import { registerStepUpHandler } from '../../services/stepUpBroker';
import apiClient from '../../services/apiClient';

/**
 * Mounts the re-auth modal and wires it to the API layer.
 *
 * apiClient cannot import React, so it asks the broker to run a challenge and
 * this provider is what actually services it. Mount once, high in the tree.
 *
 * The pending promise is held in a ref rather than state: resolving it is a
 * side effect on a value the render path never reads, and putting it in state
 * would re-render the whole subtree on every challenge.
 */
const StepUpProvider = ({ children, api = apiClient }) => {
  const [show, setShow] = useState(false);
  const pending = useRef(null);

  useEffect(() => {
    registerStepUpHandler(
      () =>
        new Promise((resolve) => {
          pending.current = resolve;
          setShow(true);
        }),
    );
    return () => registerStepUpHandler(null);
  }, []);

  const settle = useCallback((ok) => {
    setShow(false);
    const resolve = pending.current;
    pending.current = null;
    resolve?.(ok);
  }, []);

  return (
    <>
      {children}
      <StepUpModal
        show={show}
        api={api}
        onVerified={() => settle(true)}
        onCancel={() => settle(false)}
      />
    </>
  );
};

export default StepUpProvider;
